import React from "react";
import "./caseFunnel.css";
import { pickAccent } from "./caseContent";
import { CaseHero } from "./CaseHero";
import { CaseQuizForm } from "./CaseQuizForm";
import { CaseFaq, CaseProof, FinalCta, HowItWorks } from "./CaseSections";

const PreviewNotice = ({ preview, demo, status }) => {
  if (demo) return <div className="sticky top-0 z-10 bg-slate-900 px-4 py-2 text-center text-[11px] font-bold uppercase tracking-[0.12em] text-slate-100" data-testid="custom-lp-demo-banner">Private preview · form submissions are disabled</div>;
  if (preview && status !== "published") return <div className="sticky top-0 z-10 bg-amber-400 px-4 py-1.5 text-center text-xs font-bold uppercase tracking-[0.15em] text-black" data-testid="custom-lp-preview-ribbon">Preview · Status: {status?.toUpperCase()}</div>;
  return null;
};

export default function CaseFunnelView({ page, vertical, preview, demo, session, firmName, buyerCode }) {
  // Buyer landers have their own slug; funnel-specific quiz content keys off the template funnel.
  const funnel = page.match_funnel || page.template_funnel || page.slug;
  const accent = pickAccent(page.brand_color, funnel);
  return (
    <div className="cf-root bg-[#0a1929] text-slate-200" style={{ "--cf-accent": accent }} data-testid="lp-funnel-container">
      <PreviewNotice preview={preview} demo={demo} status={page.status} />
      <CaseHero page={page}>
        <CaseQuizForm
          slug={funnel}
          vertical={vertical}
          preview={preview}
          demo={demo}
          session={session}
          firmName={firmName}
        />
      </CaseHero>
      <HowItWorks />
      <CaseProof buyerCode={buyerCode} />
      <CaseFaq slug={funnel} />
      <FinalCta firmName={firmName} ctaText={vertical.ctaText} />
    </div>
  );
}
